/**
 * "Branże" / "Industries" — the same service ecosystem seen through the
 * priorities of each sector.
 */
import { el } from "../core/dom.js";
import type { AppContext } from "../core/context.js";
import { applyPageSeo } from "../core/seo.js";
import { contentSeed } from "../data/seed.js";
import { breadcrumbs } from "../components/common.js";
import { industryCard } from "../components/cards.js";

// Synchronous: industries are static positioning copy from the shared seed.
export function industriesView(ctx: AppContext): HTMLElement {
	const copy = ctx.copy();
	const seed = contentSeed(ctx.locale());

	applyPageSeo(ctx, {
		title: `${copy.nav.industries} — ${copy.brand.name}`,
		description: copy.industries.lead,
	});

	const grid = el("div", { class: "mb-grid mb-grid--3" });
	for (const industry of seed.industries) grid.appendChild(industryCard(industry, "full"));

	return el(
		"div",
		{ class: "mb-view mb-view--industries" },
		el(
			"section",
			{ class: "mb-section mb-section--white" },
			el(
				"div",
				{ class: "mb-section__inner" },
				breadcrumbs(ctx, [{ label: copy.nav.start, key: "home" }, { label: copy.nav.industries }]),
				el("h1", { class: "mb-pagehead__title" }, copy.industries.title),
				el("p", { class: "mb-pagehead__lead" }, copy.industries.lead),
				grid,
			),
		),
	);
}
